import { ActionButton } from "@hdi-seguros/web-components.action-button";
import {
  ColSize,
  ContentSection,
  Form,
  InputForm,
  RowSize,
  SelectForm,
} from "../../../../../../../../../shared/components";
import { SearchOutlined } from "@ant-design/icons";
import { Form as FormAntd } from "antd";
import { ValidateForm } from "../../../../../../../../../shared/utils";
import {
  GenericDataFormContext,
  QuotationInfoContext,
  StepOneFormContext,
} from "../../../../contexts";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { LoadedReprensentantsList } from "./components/LoadedReprensentantsList";
import { StepOneFormRepresentative } from "../../../../../utils";
import QuotationService from "../../../../../../../../../shared/services/quotation";
import {
  BINARY_VALUES,
  SelectOption,
} from "../../../../../../../../../shared/interfaces";
import MasterService from "../../../../../../../../../shared/services/master";

export const LoadLegalRepresentative = () => {
  const validateForm = new ValidateForm();
  const [reprensentativeLegalTypes, setReprensentativeLegalTypes] =
    useState<Array<SelectOption>>();
  const [countryList, setCountryList] = useState<Array<SelectOption>>([]);

  const {
    legalRepresentativeDataForm,
    setLegalRepresentativeSelected,
    setClientListModalIsOpen,
    setIsRepresentativeModal,
  } = useContext(StepOneFormContext);

  const {
    loadingRenewalQuotation,
    quotationToRenewal,
  } = useContext(QuotationInfoContext);

  const isRenewal = loadingRenewalQuotation || quotationToRenewal;

  const {
    documentTypeList,
    isLoadingLocalities,
    provinceList,
    setLocalities,
    getLocalitiesByProvinceFromState,
    getLocalitiesPerProvince
  } = useContext(GenericDataFormContext);

  const onSelectProvince = async () => {
    legalRepresentativeDataForm.resetFields(["location"]);
    setLocalities([]);
  };

  const provinceSelected: string = FormAntd.useWatch(
    "province",
    legalRepresentativeDataForm
  );

  const fetchRepresentantivesTypes = async () => {
    const response = await QuotationService.getLegalRepresentativeTypes();
    setReprensentativeLegalTypes(response);
  };

 

 

  const getCountriesList = useCallback(async () => {
    try {
      const response = await MasterService.getListCountries();

      if (response.data) {
        const economyActivities = response.data.paises.map(
          ({ descripcionPais, codigoPais }) => ({
            label: descripcionPais,
            value: codigoPais,
          })
        );
        setCountryList(economyActivities);
      }
    } catch {}
  }, [setCountryList]);
   useEffect(() => {
    fetchRepresentantivesTypes();
    getCountriesList();
  }, [getCountriesList]);

  useEffect(() => {
    if (provinceSelected?.length) {
      getLocalitiesPerProvince(provinceSelected);
    }
  }, [provinceSelected, getLocalitiesPerProvince]);

  const localities = useMemo(
    () => getLocalitiesByProvinceFromState(provinceSelected),
    [provinceSelected, getLocalitiesByProvinceFromState]
  );

  const localitiesSelectorEnabled = useMemo(
    () => Boolean(localities?.length),
    [localities]
  );

  const handlerOnClick = async () => {
    try {
      await legalRepresentativeDataForm.validateFields();

      const {
        fullName,
        gender,
        documentType,
        documentNumber,
        cuit,
        cuil,
        birthday,
        country,
        address,
        location,
        email,
        phone,
        representativeType
      }: StepOneFormRepresentative =
        legalRepresentativeDataForm.getFieldsValue();
      
      const representativeLegal = {
        peAsen: BINARY_VALUES.ZERO,
        peNomb: fullName,
        pesexo: gender ?? BINARY_VALUES.ZERO,
        peEsci: BINARY_VALUES.ONE,
        petido: documentType,
        peNdni: documentNumber,
        peNcui: cuit ?? '',
        peCuil: cuil ?? '',
        pefnac: birthday ?? '',
        pelnac: country ?? '',
        pepain: BINARY_VALUES.ONE,
        penaci: country ?? '',
        pedomi: address ?? '',
        pecopo: location ?? '',
        pecops: BINARY_VALUES.ZERO,
        pemail: email ?? '',
        peNte1: phone ?? '',
        peNte2: BINARY_VALUES.ZERO,
        peNte3: BINARY_VALUES.ZERO,
        peCrep: representativeType,
      };

      setLegalRepresentativeSelected((prev) =>
        prev ? [...prev, representativeLegal] : [representativeLegal]
      );

      legalRepresentativeDataForm.resetFields();
    } catch (error) {}
  };

  const handlerModalRepresentative = async () => {
    setClientListModalIsOpen(true);
    setIsRepresentativeModal(true);
  };

  return (
    <Form
      formProps={{
        form: legalRepresentativeDataForm,
        name: "insured-registration-form",
        onFinish: handlerOnClick,
      }}
    >
      <ContentSection level="h3" title="Representantes Legales">
        <RowSize>
          <ColSize size={25}>
            <InputForm
              formProps={{
                label: "Apellido y Nombre:",
                name: "fullName",
                rules: validateForm.generateRules({
                  label: "apellido y nombre",
                  rules: ["required"],
                }),
              }}
              inputProps={{ placeholder: "Apellido y nombre", disabled: isRenewal }}
            />
          </ColSize>

          <ColSize size={25}>
            <SelectForm
              formProps={{
                label: "Tipo de Documento:",
                name: "documentType",
                rules: validateForm.generateRules({
                  label: "tipo de documento",
                  rules: ["required"],
                }),
              }}
              selectProps={{
                loading: !documentTypeList,
                options: documentTypeList,
                disabled: isRenewal,
              }}
            />
          </ColSize>

          <ColSize size={25}>
            <InputForm
              formProps={{
                label: "Número de Documento:",
                name: "documentNumber",
                rules: validateForm.generateRules({
                  label: "numero de documento",
                  rules: ["required"],
                }),
              }}
              inputProps={{ placeholder: "Número de documento", maxLength: 8, disabled: isRenewal   }}
            />
          </ColSize>

          <ColSize size={25}>
            <InputForm
              formProps={{
                label: 'CUIT:',
                name: "cuit",
                rules: validateForm.generateRules({
                    label: 'CUIT (Solo números, sin guiones)',
                    rules: ['required', 'minLength:11', 'maxLength:11','cuil'],
                  }),
              }}
              inputProps={{ placeholder: "Cuit (Solo números, sin guiones)", disabled: isRenewal }}
            />
          </ColSize>

          <ColSize size={25}>
            <InputForm
              formProps={{
                label: "CUIL:",
                name: "cuil",
                 rules: validateForm.generateRules({
                    label: 'Cuil (Solo números, sin guiones)',
                    rules: ['required', 'minLength:11', 'maxLength:11', 'cuil'],
                  }),
              }}
              inputProps={{ placeholder: "CUIL (Solo números, sin guiones)", disabled: isRenewal }}
            />
          </ColSize>

          <ColSize size={25}>
            <SelectForm
              formProps={{
                label: "País:",
                name: "country",
              }}
              selectProps={{
                showSearch: true,
                options: countryList,
                disabled: isRenewal
              }}
            />
          </ColSize>

          <ColSize size={25}>
            <SelectForm
              formProps={{
                label: "Provincia:",
                name: "province",
              }}
              selectProps={{
                showSearch: true,
                loading: !provinceList,
                onSelect: onSelectProvince,
                options: provinceList,
                disabled: isRenewal
              }}
            />
          </ColSize>

          <ColSize size={25}>
            <SelectForm
              formProps={{
                label: "Localidad:",
                name: "location",
              }}
              selectProps={{
                disabled: isRenewal || !localitiesSelectorEnabled,
                loading: isLoadingLocalities,
                options: localities,
                showSearch: true
              }}
            />
          </ColSize>

          <ColSize size={25}>
            <InputForm
              formProps={{
                label: "Teléfono:",
                name: "phone",
              }}
              inputProps={{ placeholder: "Número de télefono", disabled: isRenewal }}
            />
          </ColSize>

          <ColSize size={25}>
            <InputForm
              formProps={{
                label: "E-mail Contacto:",
                name: "email",
              }}
              inputProps={{ placeholder: "Correo Electronico", disabled: isRenewal }}
            />
          </ColSize>

          <ColSize size={25}>
            <SelectForm
              formProps={{
                label: "Tipo de representante legal:",
                name: "representativeType",
                rules: validateForm.generateRules({
                  label: "tipo de reprensentante legal",
                  rules: ["required"],
                }),
              }}
              selectProps={{
                options: reprensentativeLegalTypes,
                disabled: isRenewal
              }}
            />
          </ColSize>

          <ColSize size={25}>
            <FormAntd.Item label=" ">
              <ActionButton
                className='btn-accent-outline-barbuss'
                type='secondary'
                label="Buscar Representante Legal"                
                icon={<SearchOutlined />}
                onClick={() => {
                  handlerModalRepresentative();
                }}
                style={{ marginRight: 15, width: 250, height: 32 }}
                disabled={isRenewal}
              />
            </FormAntd.Item>
          </ColSize>

          <ColSize size={25}>
            <FormAntd.Item label=" ">
              <ActionButton
                className='btn-principal-barbuss'
                label="Agregar"
                onClick={() => handlerOnClick()}
                style={{ width: 125 }}
              />
            </FormAntd.Item>
          </ColSize>
        </RowSize>
        <LoadedReprensentantsList />
      </ContentSection>
    </Form>
  );
};
